import React, { createContext, useContext, useEffect, useState } from "react";
import { api, loadConfig } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      await loadConfig();
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await loadConfig();
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout request failed (clearing session anyway)", e); }
    setUser(false);
  };

  const hasPerm = (module) => {
    if (!user) return false;
    if (user.is_super) return true;
    if (!user.permissions) return true;
    return user.permissions.includes(module);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, hasPerm, isSuper: !!user?.is_super }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
